document.addEventListener("DOMContentLoaded", function () {
  // Sticky Header
  const header = document.querySelector('.site-header');
  const scrollThreshold = 1;

  function updateHeaderClass() {
    if (!header) return; // Guard clause for page editor
    
    if (window.scrollY > scrollThreshold) {
      header.classList.add("scrolled");
    } else {
      header.classList.remove("scrolled");
    }
  }

  // Check on page load
  updateHeaderClass();

  // Check on scroll
  document.addEventListener("scroll", updateHeaderClass);

  // Mobile Navigation
  const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
  const mobileMenu = document.querySelector('.mobile-menu');
  const body = document.body;

  if (mobileMenuToggle && mobileMenu) {
    // Toggle mobile menu
    mobileMenuToggle.addEventListener('click', function() {
      const isExpanded = this.getAttribute('aria-expanded') === 'true';

      // Update ARIA attributes
      this.setAttribute('aria-expanded', !isExpanded);
      mobileMenu.setAttribute('aria-hidden', isExpanded);

      // Toggle body scroll lock
      if (!isExpanded) {
        // Focus first menu item
        const firstMenuItem = mobileMenu.querySelector('a');
        if (firstMenuItem) {
          firstMenuItem.focus();
        }
      } else {
        // Return focus to toggle button
        this.focus();
      }
    });

    // Close mobile menu when clicking outside
    mobileMenu.addEventListener('click', function(e) {
      if (e.target === mobileMenu) {
        closeMobileMenu();
      }
    });

    // Close mobile menu with Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && mobileMenu.getAttribute('aria-hidden') === 'false') {
        closeMobileMenu();
      }
    });

    // Close mobile menu when clicking on menu links
    const mobileMenuLinks = mobileMenu.querySelectorAll('a');
    mobileMenuLinks.forEach(link => {
      link.addEventListener('click', function() {
        closeMobileMenu();
      });
    });

    // Close mobile menu function
    function closeMobileMenu() {
      mobileMenuToggle.setAttribute('aria-expanded', 'false');
      mobileMenu.setAttribute('aria-hidden', 'true');
      body.style.overflow = '';
      mobileMenuToggle.focus();
    }

    // Handle window resize
    window.addEventListener('resize', function() {
      if (window.innerWidth > 768) {
        closeMobileMenu();
      }
    });
  }
});

